import React from "react";

import AllCards from "../Components/Roi/AllCards"
export default function InvestmentInfoPage(props){
    return (<>
    <AllCards />
    </>);
}